var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.802,
    height: 14.407,
    viewBox: "0 0 28.802 14.407",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(-1041.599 -692.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,10.871,5.436,5.436,0,0",
    transform: "translate(1063.715 694.064)",
    fill: "none",
    stroke: "#0e0377",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H26.3",
    transform: "translate(1042.849 699.5)",
    fill: "none",
    stroke: "#0e0377",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBtn);
export default __webpack_public_path__ + "static/media/arrow-right-btn.bd6bc8ad2edca6760c710ac228188b3a.svg";
export { ForwardRef as ReactComponent };